import { SERVICE_FRAGMENT } from '../@shared-fragments/serviceFragment';
import { mapService } from '../@shared-mappers/mapService';

import { createQueryHook } from '~/shared/providers/api';

interface GetRouteServicesVariables {
  routeId: string;
}

export const useRouteServicesQuery = createQueryHook(
  'transportation.routeServices',
  (variables: GetRouteServicesVariables) => ({
    services: {
      __args: {
        filter: {
          routeIds: [variables.routeId],
        },
        pagination: { offset: 0, limit: 100 },
      },
      entries: { ...SERVICE_FRAGMENT },
    },
  }),
  {
    select: (data) => (data?.services?.entries ?? []).map(mapService),
  },
);
